import { Link } from "react-router-dom";
import {
  getSortedPosts,
  getPostHref,
  formatBlogDate,
  readMoreLabel,
} from "../../content/blogPosts";
import styles from "./RelatedPosts.module.css";

interface RelatedPostsProps {
  // Turkish slug of the current post (the stable identifier), excluded from the list.
  currentSlug: string;
  lang: "tr" | "en";
}

const UI = {
  tr: { heading: "İlgili yazılar" },
  en: { heading: "Related articles" },
};

const MAX_RELATED = 3;

/**
 * "Related articles" list shown at the foot of a blog post. Surfaces the most
 * recent other posts (excluding the current one) to keep readers on-site and
 * strengthen internal linking for SEO.
 */
function RelatedPosts({ currentSlug, lang }: RelatedPostsProps): JSX.Element | null {
  const ui = UI[lang];
  const related = getSortedPosts()
    .filter((p) => p.slug !== currentSlug)
    .slice(0, MAX_RELATED);

  if (related.length === 0) {
    return null;
  }

  return (
    <nav className={styles.related} aria-label={ui.heading}>
      <h2 className={styles.heading}>{ui.heading}</h2>
      <ul className={styles.list}>
        {related.map((post) => {
          const content = post[lang];
          return (
            <li key={post.slug} className={styles.item}>
              <Link className={styles.link} to={getPostHref(post, lang)}>
                <time className={styles.date} dateTime={post.date}>
                  {formatBlogDate(post.date, lang)}
                </time>
                <span className={styles.title}>{content.title}</span>
                <span className={styles.readMore}>{readMoreLabel[lang]} →</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default RelatedPosts;
